<template>
    <b-card no-body>
        <b-card-header class="p-3 d-flex justify-content-between align-items-center">
                <h3 class="mb-0">Redemption</h3>
                <!-- <div class="d-flex align-items-center text-primary">
                    <p class="text-primary">View All</p>
                </div> -->
            </b-card-header>
            <div class="m-3">
                <div class="mb-3">
                    <span class="text-muted text-xs">Disbursement Status</span>
                    <p class="text-warning font-weight-600">{{ activeCase.disb_status || "-" }}</p>
                </div>
                <div class="mb-3">
                    <span class="text-muted text-xs">Actual Settlement Amt.</span>
                    <p class="font-weight-600 text-danger">RM {{ activeCase.settlement_actual_amt | moneyFormatter }}</p>
                </div>
                <div class="mb-3">
                    <span class="text-muted text-xs">Facility Type</span>
                    <p class="font-weight-600">{{ activeCase.facility_type || "-" }}</p>
                </div>
            </div>
    </b-card>
</template>
<script>
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'
export default {
	computed: {
    ...mapState(useLoanCaseStore, ['activeCase']),
	}	
}
</script>